import { OPERATIONS, SUPPORTED_FORMATTER_PATTERNS } from '../../../../../constants';
export var PATTERNS_OPTIONS = SUPPORTED_FORMATTER_PATTERNS.map(function (pattern) {
  return {
    label: pattern,
    value: pattern
  };
});
export var OPERATIONS_OPTIONS = OPERATIONS.map(function (operation) {
  return {
    label: operation.replace(/^\w/, function (c) {
      return c.toUpperCase();
    }),
    value: operation
  };
});